import * as authActions from './auth/actions';
import * as dsConfigActions from './dsconfig/actions';
import * as templatesActions from './templates/actions';
import * as parsedTreesActions from './parsedTrees/actions'
import * as designsActions from './designs/actions';
import * as foldersActions from './folders/actions';
import * as userFilesActions from './userFiles/actions';
import * as storageActions from './storage/actions';
import * as dealersActions from './dealers/actions';
import * as brandsActions from './brands/actions';
import * as brandsImagesActions from './brandsImages/actions';
import * as userConfigActions from './userConfig/actions';
import * as userAccessActions from './userAccess/actions';
import * as industriesActions from './industries/actions'
export default {
  auth: authActions,
  dsConfig: dsConfigActions,
  templates: templatesActions,
  parsedTrees: parsedTreesActions,
  designs: designsActions,
  folders: foldersActions,
  userFiles: userFilesActions,
  storage: storageActions,
  dealers: dealersActions,
  brands: brandsActions,
  brandsImages: brandsImagesActions,
  userConfig: userConfigActions,  
  userAccess: userAccessActions,
  industries: industriesActions
}